import Store                from "Dashboard/Core/Store";
import Utils                from "Dashboard/Utils/Utils";
import { Schedule }         from "Utils/API";



// The initial State
const initialState = {
    loading    : true,
    error      : false,
    edition    : 0,
    canCreate  : false,
    canEdit    : false,
    canFilter  : false,
    canImport  : false,
    canExport  : false,
    list       : [],
    total      : 0,
    elem       : {},
    categories : [],
    activities : [],
    statuses   : [],
    sort       : {
        orderBy  : "finalPosition",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "SCHEDULE_LOADING" });
    },

    /**
     * Fetches the Schedule List
     * @param {Function} dispatch
     * @param {Object=}  params
     * @returns {Promise}
     */
    async fetchList(dispatch, params = {}) {
        const data = await Schedule.getAll(params);
        data.sort = params;
        dispatch({ type : "SCHEDULE_LIST", data });
    },

    /**
     * Fetches a single Schedule
     * @param {Function} dispatch
     * @param {Number}   scheduleID
     * @returns {Promise}
     */
    async fetchElem(dispatch, scheduleID) {
        const data = await Schedule.getOne({ scheduleID });
        dispatch({ type : "SCHEDULE_ELEM", data });
    },

    /**
     * Fetches the Schedule Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await Schedule.getEditData();
        dispatch({ type : "SCHEDULE_EDIT", data });
    },

    /**
     * Edits/Creates a Schedule
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return Schedule.edit(data);
    },

    /**
     * Deletes a Schedule
     * @param {Function} dispatch
     * @param {Number}   scheduleID
     * @returns {Promise}
     */
    deleteElem(dispatch, scheduleID) {
        return Schedule.delete({ scheduleID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.forNazarText = Utils.toYesNo(elem.forNazar);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "SCHEDULE_LIST", "SCHEDULE_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "SCHEDULE_LOADING":
        return {
            ...state,
            loading    : true,
        };

    case "SCHEDULE_LIST":
        return {
            ...state,
            loading    : false,
            error      : false,
            canCreate  : action.data.canCreate,
            canEdit    : action.data.canEdit,
            canFilter  : action.data.canFilter,
            canImport  : action.data.canImport,
            canExport  : action.data.canExport,
            list       : Utils.parseList(action.data.list, parseElem),
            total      : action.data.total,
            sort       : action.data.sort,
        };

    case "SCHEDULE_ELEM":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            elem       : parseElem(action.data.elem),
            categories : action.data.categories,
            activities : action.data.activities,
            statuses   : action.data.statuses,
        };

    case "SCHEDULE_EDIT":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            categories : action.data.categories,
            activities : action.data.activities,
            statuses   : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
